import { createStandardAction } from 'typesafe-actions';

export const blockPausePauseOverlay = createStandardAction(
  'playPauseOverlay/BLOCK'
)<string>();

export const unblockPausePauseOverlay = createStandardAction(
  'playPauseOverlay/UNBLOCK'
)<string>();
